module.exports = __webpack_public_path__ + "static/media/1_transformed.0488a49e.png";